import PartnerCategoriesView from "./PartnerCategoriesView";

export default PartnerCategoriesView;
